const React = require('react');
const {View} = require('react-native');

const useSafeAreaInsets = () => ({top: 0, right: 0, bottom: 0, left: 0});
const useSafeAreaFrame = () => ({x: 0, y: 0, width: 390, height: 844});
const SafeAreaView = ({children, style}) => React.createElement(View, {style}, children);
const SafeAreaProvider = ({children}) => children;

const SafeAreaInsetsContext = React.createContext({top: 0, right: 0, bottom: 0, left: 0});

module.exports = {
  useSafeAreaInsets, useSafeAreaFrame,
  SafeAreaView, SafeAreaProvider,
  SafeAreaConsumer: SafeAreaInsetsContext.Consumer,
  SafeAreaInsetsContext,
  initialWindowMetrics: {insets:{top:0,right:0,bottom:0,left:0}, frame:{x:0,y:0,width:390,height:844}},
};
